import { getItem } from '@purple-dot/browser-sdk/src/libraries/local-storage';

type InternalUserData = {
  isInternalUser: boolean;
};

type TrackProperties = Record<string, unknown>;

function isInternalUser(): boolean {
  const internalUser = getItem('internal-user') as InternalUserData | null;
  if (!internalUser) {
    return false;
  }

  return internalUser.isInternalUser === true;
}

function isKnownBot(): RegExpMatchArray | null {
  const BOTS = /(pingdom)|(google)/i;
  return global.navigator.userAgent.match(BOTS);
}

const FilterWrapper = {
  track: (event: string, properties?: TrackProperties) => {
    if (!(isInternalUser() || isKnownBot())) {
      window.FS?.('trackEvent', { name: event, properties });
    } else {
      // biome-ignore lint/suspicious/noConsole: debug
      console.log('INTERNAL USER - Track: ', event, properties);
    }
  },
};

const Analytics = {
  ...FilterWrapper,

  trackProductViewed: ({ itemId, slug }: { itemId: string; slug: string }) => {
    if (!itemId) {
      throw new Error('No itemId provided to Analytics.trackProductViewed()');
    }
    if (!slug) {
      throw new Error('No slug provided to Analytics.trackProductViewed()');
    }

    FilterWrapper.track('Product Viewed', { itemId, slug, product_id: slug });
  },

  trackOrderCreated: ({ orderReference }: { orderReference: string }) => {
    if (!orderReference) {
      throw new Error(
        'No orderReference provided to Analytics.trackOrderCreated()'
      );
    }

    FilterWrapper.track('Order Created', { orderReference });
  },

  trackLastSeenProductClicked: () => {
    FilterWrapper.track('Last Seen Product Clicked');
  },

  trackInputChanged: ({ name }: { name: string }) => {
    if (!name) {
      throw new Error('No name provided to Analytics.trackInputChanged');
    }

    FilterWrapper.track(`${name} Changed`);
  },

  trackUserProgressed: (pageName: string) => {
    if (!pageName) {
      throw new Error('No page provided to Analytics.trackUserProgressed');
    }
    FilterWrapper.track('User Progressed', { pageName });
  },
};

export default Analytics;
